import { render, staticRenderFns } from "./ProductionReportList.vue?vue&type=template&id=65b276bb&scoped=true"
import script from "./ProductionReportList.vue?vue&type=script&lang=js"
export * from "./ProductionReportList.vue?vue&type=script&lang=js"
import style0 from "./ProductionReportList.vue?vue&type=style&index=0&id=65b276bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b276bb",
  null
  
)

export default component.exports